import { object, array, string } from '@gogame/schemas';

import {
  COLUMN_ID,
  COLUMN_PERIOD,
  COLUMN_NAME,
  COLUMN_APPLICATION,
  COLUMN_NETWORK,
  COLUMN_PLATFORMS,
  COLUMN_BRIEFS,
  COLUMN_TOTAL_BUDGET,
  COLUMN_COST_MODELS,
  COLUMN_AGENCIES,
  COLUMN_INFLUENCER_CHANNELS,
  COLUMN_INFLUENCER_CAMPAIGNS,
  COLUMN_LAST_UPDATED_BY,
  COLUMN_LAST_UPDATED_DATE,
  COLUMN_CREATED_BY,
  COLUMN_CREATED_DATE,
} from 'scenes/Influencers/MasterCampaigns/constants';

export const columnsSchema = object({
  order: array(string()).default([
    COLUMN_ID,
    COLUMN_NAME,
    COLUMN_PERIOD,
    COLUMN_APPLICATION,
    COLUMN_NETWORK,
    COLUMN_PLATFORMS,
    COLUMN_BRIEFS,
    COLUMN_TOTAL_BUDGET,
    COLUMN_COST_MODELS,
    COLUMN_AGENCIES,
    COLUMN_INFLUENCER_CHANNELS,
    COLUMN_INFLUENCER_CAMPAIGNS,
    COLUMN_LAST_UPDATED_BY,
    COLUMN_LAST_UPDATED_DATE,
    COLUMN_CREATED_BY,
    COLUMN_CREATED_DATE,
  ]),
  collapsed: array(string()).default([]),
});
